export default "__VITE_ASSET__09f0843f__"